import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  title: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
  tabs: {
    width: '410px',
    marginBottom: theme.spacing(4),
  },
  gridWrapper: {
    flexGrow: 1,
    marginBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

export const useOrgDetailsStyles = makeStyles((theme) => ({
  title: {
    marginBottom: theme.spacing(2),
    lineHeight: '24px',
  },
  description: {
    marginBottom: theme.spacing(2),
  },
  table: {
    marginTop: theme.spacing(3),
  },
  searchField: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: 0,
    width: 376,
    [theme.breakpoints.down('xs')]: {
      minWidth: '100%',
      width: 'unset',
    },

    //NOSONAR TODO: CDS-590
    '& #search-field-input': {
      padding: '12px 16px',
    },
  },
}));
